import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import Preloader from "./Preloader";
import { isAllowed, usePermissions } from "../context/usePermissions";

export const AccessDenied = ({ message }) => {
    const { role, error, refresh } = usePermissions();
    return (
        <div className="container-fluid">
            <Card className="mt-3">
                <Card.Body className="text-center py-5">
                    <ShieldAlert size={40} className="text-warning mb-3" />
                    {error && !role ? (
                        <>
                            <h5 className="mb-2">Couldn't load your permissions</h5>
                            <p className="text-muted mb-3">Check your connection and try again.</p>
                            <Button size="sm" onClick={refresh}>
                                Retry
                            </Button>
                        </>
                    ) : (
                        <>
                            <h5 className="mb-2">You don't have access to this page</h5>
                            <p className="text-muted mb-3">
                                {message ||
                                    (role
                                        ? `Your role (${role.name}) doesn't include this feature. Ask a Root Admin if you need it.`
                                        : "Your account has no role assigned yet. Ask a Root Admin to assign one.")}
                            </p>
                            <Link to="/dashboard" className="btn btn-primary btn-sm">
                                Back to Dashboard
                            </Link>
                        </>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

// Wraps a route element; `permission` is a spec as described in usePermissions.
const RequirePermission = ({ permission, children }) => {
    const { loading, can } = usePermissions();
    if (!permission) return children;
    if (loading) return <Preloader />;
    return isAllowed(can, permission) ? children : <AccessDenied />;
};

export default RequirePermission;
